import { LoginResponse } from './../../models/auth.interface';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Utils } from '../../utils/utils';
import axios from 'axios';
import { AppSettings } from '@/config/app-settings';
import { LoginPayload } from '@/models/auth.interface';
import { User } from '@/models/user.interface';
import jwtDecode from 'jwt-decode';

@Module
export default class AuthStore extends VuexModule {
  /* tslint:disable */
  private _loggedIn: boolean = Utils.isLoggedIn();
  private _loginError: boolean = false;
  private _userConnected: User | null = null;
  /* tslint:enable */

  @Mutation public loginMut(payload: LoginResponse): void {
    if (payload && payload.success) {
      this._loggedIn = true;
      sessionStorage.setItem('jwt', payload.token as string);
      axios.defaults.headers.common.Authorization = `JWT ${payload.token}`;
      this._userConnected = (jwtDecode(sessionStorage.getItem('jwt') as string) as any)._doc;
      this._loginError = false;
    } else {
      this._userConnected = null;
      this._loggedIn = false;
      this._loginError = true;
    }
  }

  @Mutation public logoutMut() {
    sessionStorage.clear();
    this._userConnected = null;
    this._loggedIn = false;
    this._loginError = false;
  }

  @Mutation public ensureUserConnectedMut() {
    this._userConnected = (jwtDecode(sessionStorage.getItem('jwt') as string) as any)._doc;
  }

  @Action({ commit: 'loginMut' }) public async loginAction(payload: LoginPayload) {
    try {
      const response = await axios.post<LoginResponse>(`${process.env.VUE_APP_API_URL}/auth/login`, {
        email: payload.email,
        password: payload.password,
      });
      if (response.data.success) {
        return response.data;
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  }

  @Action({ commit: 'logoutMut' }) public logoutAction(): void {
    return;
  }

  @Action({ commit: 'ensureUserConnectedMut' }) public ensureUserConnectedAction(): void {
    return;
  }

  get loggedIn(): boolean {
    return this._loggedIn;
  }

  get loginError(): boolean {
    return this._loginError;
  }

  get userConnected(): User | null {
    return this._userConnected;
  }
}
